import request from './Request';
import config from '../config';

const service = {}

service.create = (body, vendorApiKey, locationApiKey) => {
  let url = `/${config.adminVersion}/vendors/${vendorApiKey}/cashiers/`;
  return request.post(url, body, true)
    .then(data => data);
};

service.list = (vendorApiKey, locationApiKey) => {
  let url = `/${config.adminVersion}/vendors/${vendorApiKey}/cashiers/`;
  return request.protectedGet(url, true)
    .then(data => data);
};

service.update = (body, vendorApiKey, locationApiKey, cashierApiKey) => {
  let url = `/${config.adminVersion}/vendors/${vendorApiKey}/cashiers/${cashierApiKey}/`;
  return request.put(url, body, true)
    .then(data => data);
};


export default service



/** WEBPACK FOOTER **
 ** ./src/services/cashier.js
 **/